import { Component, type ReactNode, type ErrorInfo } from "react";
import { ServerErrorPage } from "../pages/ServerErrorPage";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <ServerErrorPage onRetry={() => this.setState({ error: null })} />
      );
    }
    return this.props.children;
  }
}
